Object.defineProperty(exports,"__esModule",{value:true});var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}




var yellow200="#FFF59D";
var deepOrange600="#F4511E";
var lime300="#DCE775";
var lightGreen500="#8BC34A";
var teal700="#00796B";
var cyan900="#006064";
var colors=[
deepOrange600,
yellow200,
lime300,
lightGreen500,
teal700,
cyan900];

var blueGrey50="#ECEFF1";
var blueGrey300="#90A4AE";
var blueGrey700="#455A64";
var grey900="#212121";



var sansSerif="'Roboto', 'Helvetica Neue', Helvetica, sans-serif";
var letterSpacing="normal";
var fontSize=12;



var padding=8;
var baseProps={
width:350,
height:350,
padding:50};




var baseLabelStyles={
fontFamily:sansSerif,
fontSize:fontSize,
letterSpacing:letterSpacing,
padding:padding,
fill:blueGrey700,
stroke:"transparent",
strokeWidth:0};


var centeredLabelStyles=(0,_assign3.default)({textAnchor:"middle"},baseLabelStyles);



var strokeDasharray="10, 5";
var strokeLinecap="round";
var strokeLinejoin="round";exports.default=

{
area:(0,_assign3.default)({
style:{
data:{
fill:grey900},

labels:centeredLabelStyles}},

baseProps),
axis:(0,_assign3.default)({
style:{
axis:{
fill:"transparent",
stroke:blueGrey300,
strokeWidth:2,
strokeLinecap:strokeLinecap,
strokeLinejoin:strokeLinejoin},

axisLabel:(0,_assign3.default)({},centeredLabelStyles,{
padding:padding,
stroke:"transparent"}),

grid:{
fill:"transparent",
stroke:blueGrey50,
strokeDasharray:strokeDasharray,
strokeLinecap:strokeLinecap,
strokeLinejoin:strokeLinejoin,
pointerEvents:"none"},

ticks:{
fill:"transparent",
size:5,
stroke:blueGrey300,
strokeWidth:1,
strokeLinecap:strokeLinecap,
strokeLinejoin:strokeLinejoin},

tickLabels:(0,_assign3.default)({},baseLabelStyles,{
fill:blueGrey700})}},


baseProps),
bar:(0,_assign3.default)({
style:{
data:{
fill:blueGrey700,
padding:padding,
strokeWidth:0,
width:5},

labels:baseLabelStyles}},

baseProps),
candlestick:(0,_assign3.default)({
style:{
data:{
stroke:blueGrey700},

labels:centeredLabelStyles},

candleColors:{
positive:"#ffffff",
negative:blueGrey700}},

baseProps),
chart:baseProps,
errorbar:(0,_assign3.default)({
style:{
data:{
fill:"transparent",
opacity:1,
stroke:blueGrey700,
strokeWidth:2},

labels:centeredLabelStyles}},

baseProps),
group:(0,_assign3.default)({
colorScale:colors},
baseProps),
line:(0,_assign3.default)({
style:{
data:{
fill:"transparent",
opacity:1,
stroke:blueGrey700,
strokeWidth:2},

labels:centeredLabelStyles}},

baseProps),
pie:(0,_assign3.default)({
colorScale:colors,
style:{
data:{
padding:padding,
stroke:blueGrey50,
strokeWidth:1},

labels:(0,_assign3.default)({},baseLabelStyles,{padding:20})}},

baseProps),
scatter:(0,_assign3.default)({
style:{
data:{
fill:blueGrey700,
opacity:1,
stroke:"transparent",
strokeWidth:0},

labels:centeredLabelStyles}},

baseProps),
stack:(0,_assign3.default)({
colorScale:colors},
baseProps),
tooltip:{
style:(0,_assign3.default)({},centeredLabelStyles,{padding:5,pointerEvents:"none"}),
flyoutStyle:{
stroke:grey900,
strokeWidth:1,
fill:"#f0f0f0",
pointerEvents:"none"},

cornerRadius:5,
pointerLength:10},

voronoi:(0,_assign3.default)({
style:{
data:{
fill:"transparent",
stroke:"transparent",
strokeWidth:0},

labels:(0,_assign3.default)({},centeredLabelStyles,{padding:5,pointerEvents:"none"}),
flyout:{
stroke:grey900,
strokeWidth:1,
fill:"#f0f0f0",
pointerEvents:"none"}}},


baseProps),
legend:{
colorScale:colors,
style:{
data:{
type:"circle"},

labels:baseLabelStyles}}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-theme/material.js
// module id = 1481
// module chunks = 0